import ajax from '@/libs/api.request'

export default {
    getList : param => {
        return ajax.get('/edu/web/signup/list', param)
    },

    getOne : param => {
        return ajax.get('/edu/web/signup/findOneById', param)
    },

    save : param => {
        return ajax.post('/edu/web/signup/save',param)
    },

    del : param => {
        return ajax.post('/edu/web/signup/delete',param)
    },

    getRecordList : param => {
        return ajax.post('/edu/web/signup/getRecordList',param)
    }

}

